














































































import { Component, Prop, Watch } from "vue-property-decorator";

import AppVue from "@/apps/AppVue.vue";
import { CourseAttendeeAnswerModel } from "@/core/models";
import { CourseAttendeeService } from "@/core/services";

@Component
export default class CourseAttendeeExamDetailsDialog extends AppVue {
  @Prop({ default: false }) visible: boolean;
  @Prop({ default: null }) courseSessionId: number | null;
  @Prop({ default: null }) courseAttendeeId: number | null;

  isLoading = false;
  answers: CourseAttendeeAnswerModel[] = [];

  @Watch("visible")
  async onVisibleChanged(value: boolean) {
    if (value) {
      await this.loadAnswers();
      return;
    }

    this.answers = [];
  }

  @Watch("courseAttendeeId")
  async onCourseAttendeeIdChanged() {
    if (this.visible) {
      await this.loadAnswers();
    }
  }

  private emitClose() {
    this.$emit("close");
  }

  private formatResponses(responses: string[]) {
    if (!responses || responses.length === 0) {
      return "-";
    }

    return responses.join(" / ");
  }

  private async loadAnswers() {
    if (!this.courseSessionId || !this.courseAttendeeId) {
      this.answers = [];
      return;
    }

    this.isLoading = true;

    try {
      this.answers = await CourseAttendeeService.getCourseAttendeeForSession(
        this.courseSessionId,
        this.courseAttendeeId,
      );
    } catch (err) {
      this.answers = [];
      this.handleApiGetError(err);
    } finally {
      this.isLoading = false;
    }
  }
}
